import { AppDispatch } from 'app/store'
import { fetchSelectedNavDomainThunk } from 'features/domains/slice'
import { axiosProgressUploading } from 'features/home/components/HomeConfiguration/HomeConfigFiles/HomeConfigUploadModal/HomeConfigDropZone/utils/httpProgressRequest'
import { fetchRootDomainsThunk } from 'features/rootDomains/slice'
import { Dispatch } from 'react'
import { getDealershipImageUploadURL } from './api'

export const uploadFileThunk = (
  domainId: string,
  onProgress: Dispatch<number | undefined>,
  files: FileList
) => {
  return async (dispatch: AppDispatch) => {
    try {
      const {
        data: { payload },
      } = await getDealershipImageUploadURL(domainId)
      if (payload) {
        await axiosProgressUploading(payload, files[0], onProgress)
        onProgress(undefined)
        dispatch(fetchSelectedNavDomainThunk(domainId))
        dispatch(fetchRootDomainsThunk())
      }
    } catch (e) {
      console.log('Something went wrong when company image was changing', e)
    }
  }
}
